// @flow

import clsx from 'clsx';

type Props = {
  isBeneficiary: boolean,
  isShapeUser?: boolean,
  extraCss: string,
};

const ParticipantIndicator = (props: Props): React$Node => {
  const { isBeneficiary, isShapeUser = false, extraCss } = props;

  const className = clsx({
    'shape': isShapeUser,
    'participant-indicator': true,
    'beneficiary': isBeneficiary,
    [String(extraCss)]: !!extraCss,
  });

  return (
    <div className={ className }></div>
  );
};

ParticipantIndicator.defaultProps = {
  isBeneficiary: false,
  isShapeUser: false,
  extraCss: '',
};

export default ParticipantIndicator;
